"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var SpacesFilterFiltersApplied_1 = require("../../../gen-src/icons/SpacesFilterFiltersApplied");
var SpacesFilterFiltersAppliedActive_1 = require("../../../gen-src/icons/SpacesFilterFiltersAppliedActive");
var SpacesFilterFiltersNotApplied_1 = require("../../../gen-src/icons/SpacesFilterFiltersNotApplied");
var SpacesFilterFiltersNotAppliedActive_1 = require("../../../gen-src/icons/SpacesFilterFiltersNotAppliedActive");
var SpacesFilterFiltersNotAppliedDisabled_1 = require("../../../gen-src/icons/SpacesFilterFiltersNotAppliedDisabled");
var Localize_1 = require("../../../gen-src/Localize");
var FilterPanelStyles_1 = require("../../style/FilterPanelStyles");
var FilterPanelToggleButton = /** @class */ (function (_super) {
    __extends(FilterPanelToggleButton, _super);
    function FilterPanelToggleButton(props) {
        var _this = _super.call(this, props) || this;
        _this.getIcon = function (filterState) {
            if (filterState.active || filterState.focus || filterState.hover) {
                if (_this.props.filtersApplied) {
                    return React.createElement(SpacesFilterFiltersAppliedActive_1.SvgSpacesFilterFiltersAppliedActive, null);
                }
                else {
                    return React.createElement(SpacesFilterFiltersNotAppliedActive_1.SvgSpacesFilterFiltersNotAppliedActive, null);
                }
            }
            else if (filterState.disabled) {
                return React.createElement(SpacesFilterFiltersNotAppliedDisabled_1.SvgSpacesFilterFiltersNotAppliedDisabled, null);
            }
            else if (_this.props.filtersApplied) {
                return React.createElement(SpacesFilterFiltersApplied_1.SvgSpacesFilterFiltersApplied, null);
            }
            else {
                return React.createElement(SpacesFilterFiltersNotApplied_1.SvgSpacesFilterFiltersNotApplied, null);
            }
        };
        return _this;
    }
    FilterPanelToggleButton.prototype.getButtonTestId = function () {
        return 'filter-panel' + (this.props.filtersApplied ? '-applied-filters-toggle' : '-toggle');
    };
    FilterPanelToggleButton.prototype.render = function () {
        return (React.createElement(widgets_1.ButtonWidget, { style: FilterPanelStyles_1.FilterPanelToggleButtonStyle, disabled: this.props.disabled, buttonType: widgets_1.ButtonType.Icon, getContent: this.getIcon, title: Localize_1.Messages.ToggleFilterButtonTitle(), testId: this.getButtonTestId(), handleClick: this.props.filterPanelButtonClickHandler }));
    };
    return FilterPanelToggleButton;
}(React.PureComponent));
exports.FilterPanelToggleButton = FilterPanelToggleButton;
//# sourceMappingURL=FilterPanelToggleButton.js.map